(window as any).global = window;

if ((window as any).global === 'undefined') {
  (window as any).global = window;
}
export {};
declare global {
  interface Window {
    AdobeDC: any;
  }
}
